'use strict';
import $ from 'jquery';
import Mustache from 'mustache';
import util from '../util';
import {
	applySaleCode,
	deleteSavedCard,
	updateOrderItems
} from '../api/checkout';
import gtm from '../util/gtm';
import stickyCta from '../ui/sticky-cta';
import { getCart } from '../api/cart';
import Cookie from 'js-cookie';
import ApplePay from './applepay';

/**
 * Read more toggle (shows only first paragraph on mobile)
 */
function readMoreToggle() {
	const $readMoreElem = $('.sale-code-long-description');

	$readMoreElem.each(function () {
		var $this = $(this),
			$children = $this.children('p, ul, ol, h3, h4');

		if ($children.text().length) {
			if (!$this.find('.read-more-toggle-content').length && $children.length > 1) {
				$this.addClass('read-more-toggle');

				$children.wrapAll($('<div>', { class: 'read-more-toggle-content' }).hide());
				//not($children.first())
				$('<button>', { class: 'read-more-toggle-button button btn-link', type: 'button' })
					.append($('<span>', { class: 'read-more-toggle-button-closed', html: 'Näytä lisää' }))
					.append($('<span>', { class: 'read-more-toggle-button-open', html: 'Näytä vähemmän' }))
					.appendTo($this);
			}
		}
	});

	/*$(document).on('click', '.read-more-toggle-button', function() {
		var $parent = $(this).parent();

		$parent.toggleClass('is-open').find('.read-more-toggle-content').stop(true).slideToggle(200, function() {
			if (!$parent.hasClass('is-open')) {
				var pos = $parent.offset().top - $('.header-content-mobile.sticky').outerHeight();

				if ($(window).scrollTop() > pos) {
					setTimeout(function() {
						$('html, body').stop(true).animate({
							scrollTop : pos
						}, 300);
					}, 50);
				}
			}
		});
	});*/
}

let cta;
let $currentPaymentMethod = null;

const setCurrentPaymentMethod = () => {
	let $input;
	if (Cookie.get('pan_hash')) {
		$input = $(`input[name="stage-payment-provider"][data-panhash="${Cookie.get('pan_hash')}"]`);
	}
	// if (!$input || !$input.length) {
	// 	$input = $(`input[name="stage-payment-provider"][value="${Cookie.get('payment_method')}"]`);
	// }
	$currentPaymentMethod = $input;
	return $input;
}

export const updatePaymentMethods = data => {
	const template = $('#mustache-checkout-payment-methods').html();
	const $container = $('.payment-methods-container');
	if ($('.all-payment-methods').length && !$container.find('.all-payment-methods').hasClass('hidden')) {
		data.showingAll = true;
	}
	const markup = Mustache.render(template, data);
	$container.html(markup);
	if (cta) {
		cta.reinit('.payment-cta');
		if (!$container.hasClass('skip-contact')) {
			cta.disable();
		}
	}
	setCurrentPaymentMethod();
	// preselectPaymentMethod();
	$('.checkout-payment-methods').trigger('update', [data])
}

let applePay = null;

/**
 * @return {Promise<ApplePay>}
 */
export async function initApplePay() {
	applePay = applePay || new ApplePay(null, window.applePayConfig || {});
	const applePaySupported = await applePay.canMakePayments();
	const $applePay = $('.payment-method-ApplePay').closest('li');
	if (!applePaySupported) {
		$applePay.addClass('hidden');
		const $list = $applePay.closest('ul');
		$list.siblings('ul').find('li:last-child').appendTo($list);
	} else {
		//$('.payment-method-ApplePay').prop('checked', true).trigger('change');
	}
	return applePay;
}

export default () => {
	const $container = $('.v4-checkout .checkout-payment');
	if (!$container.length) {
		return;
	}

	cta = stickyCta('.payment-cta');

	const $paymentForm = $container.find('.payment-form');
	const orderId = $container.data('order-id');
	const templates = {
		saleCodes: $('#mustache-checkout-sale-codes').html(),
		paymentMethods: $('#mustache-checkout-payment-methods').html(),
	};

	setCurrentPaymentMethod();
	// if ($currentPaymentMethod?.length) {
	// 	$currentPaymentMethod.click();
	// }

	initApplePay();

	$paymentForm.on('submit', e => {
		const selectedPaymentMethod = $('input[name="stage-payment-provider"][type="hidden"]').val() || $('input[name="stage-payment-provider"]:checked').val();
		if (selectedPaymentMethod === 'ApplePay') {
			e.preventDefault();
			const $loader = util.addFormLoader($('.continue'), {
				align: 'after',
				className: 'float-right'
			});
			updateOrderItems(orderId)
				.then(order => {
					applePay.setOrder(order);
					applePay.openModal($('.continue'));
				})
				.finally(() => $loader.done());
		}
	});

	/**
	 * @param {Object[]} saleCodes
	 * @param {String} usedSaleCode
	 */
	const updateSaleCodes = (saleCodes, usedSaleCode, isCustom, noSaleCode) => {
		const templateData = { availableSaleCodes: saleCodes };
		if (usedSaleCode) {
			templateData.isSaleCodeActive = true;
			templateData.usedSaleCode = usedSaleCode.code;
			templateData.saleCode = usedSaleCode;
			const dataLayer = window.dataLayer = window.dataLayer || [];
			dataLayer.push({
				event: 'checkout',
				ecommerce: {
					checkout: {
						actionField: {
							coupon: usedSaleCode.code
						}
					}
				}
			});
		}
		if (isCustom) {
			templateData.isCustomSaleCode = true;
		}

		if (noSaleCode) {
			templateData.noSaleCode = true;
		}

		const markup = Mustache.render(templates.saleCodes, templateData);
		$container.find('.checkout-discounts-selector').html(markup);
		readMoreToggle();
	}

	/*
	const refreshPaymentMethods = () => {
		const $el = $container.find('.payment-methods-container')
		const $loader = util.addFormLoader($el, { className: 'overlay' });
		return getPaymentMethods()
			.then(updatePaymentMethods)
			.tap(() => $loader.done());
	}
	*/

	/**
	 * Hide previously saved credit card on delete.
	 *
	 * Hide saved card from the DOM to prevent a page reload.
	 * If there is only one saved card, hide the whole container with all saved cards.
	 *
	 * @param {JQuery} $savedCardTile - jQuery DOM element
	 * @returns {void}
	 */
	const hideSavedCard = $savedCardTile => {
		const $allSavedCardsParent = $savedCardTile.parent();
		const $savedCardPaymentMethodContainer = $savedCardTile.parent().parent();

		// Count how many div elements has class `payment-method-tile-saved`
		const $initialSavedCardCount = $allSavedCardsParent.find('.payment-method-tile-saved').length;

		// Check which cards with a class `payment-method-tile-saved` are visible
		// This is needed to determine if the last card was deleted when DOM manipulation had been done
		const $savedCardsVisibleBeforeClick = $allSavedCardsParent.find('.payment-method-tile-saved').filter(':visible').length;

		// Check if there is only one saved card or if the last card was deleted (in the case of multiple saved cards)
		if ($initialSavedCardCount === 1 || $savedCardsVisibleBeforeClick === 1) {

			// Find <h3> elements associated with saved cards and remove them
			const $savedCardTitles = $savedCardPaymentMethodContainer.find('h3.saved-cards');
			for (let i = 0; i < $savedCardTitles.length; i++) {
				$savedCardTitles[i].remove();
			}
			$allSavedCardsParent.fadeOut();
		} else {
			$savedCardTile.fadeOut();
		}
	}

	const isPaymentMethodAvailable = methods => {
		const selectedPaymentMethod = $('input[name="stage-payment-provider"]').val();
		const isAvailable = !!methods.filter(method => method.id === selectedPaymentMethod).length;
		return isAvailable;
	}

	const checkSaleCodePaymentMethods = payment => {
		const paymentLimited = !!$container.find('.payment-methods-list.limited').length;
		if (payment.limited || paymentLimited) {
			if (!payment.limited) {
				// show all available methods
				updatePaymentMethods(payment);
			}
			else if (payment.paymentMethods) {
				if (!isPaymentMethodAvailable(payment.paymentMethods) && $container.hasClass('checkout-oneclick')) {
					$('.checkout-payment-methods').trigger('edit', [payment]);
				} else {
					updatePaymentMethods(payment);
				}
			}
		}
	}

	/**
	 * @param {String} code
	 */
	const setSaleCode = (code = '', isCustom = false, voucherId, noSaleCode) => {
		const action = applySaleCode(code, orderId, isCustom, voucherId).tap(res => {
			if (res && (res.result === true || parseInt(res.result) === 1)) {
				$('#set-salecode').val(code);
				const { saleCode, payment } = res;
				const isFreeDelivery = saleCode && saleCode.freeDelivery;
				if (isFreeDelivery || $('.available-sale-codes').hasClass('free-delivery')) {
					$('.shipping-method .checkout-oneclick-form').trigger('update');
				}
				updateSaleCodes(res.salecodes || [], saleCode, isCustom, noSaleCode);
				if (payment) {
					// update payment methods if needed
					checkSaleCodePaymentMethods(payment);
				}
			} else {
				$('.available-sale-codes input').prop('checked', false);
			}
			return true;
		});
		$('.checkout-cart').trigger('cartaction', [action, cta]);
		return action;
	}

	/*
	$container
		.find('.payment-methods-container')
		.on('action', refreshPaymentMethods);
	*/

	$container
		// Select payment method
		.on('change', 'input[name="stage-payment-provider"]', e => {
			cta.enable();
			$(window).trigger('scroll');

			const $input = $(e.target);
			const $info = $input.closest('div');
			const $paymentSection = $input.closest('.checkout-payment-methods');
			$paymentSection.find('input[name="stage-payment-provider"]').removeClass('validation-error');
			$paymentSection.find('.validation-alert').slideUp('fast', function() {
				$(this).remove();
			});
			Cookie.set('payment_method', $input.val());

			if ($input.data('panhash')) {
				Cookie.set('pan_hash', $input.data('panhash'));
			} else {
				Cookie.remove('pan_hash');
			}

			const $additionalInfo = $info.find('.payment-method-additional-info');
			$('.payment-method-additional-info').addClass('hidden');
			$('.pci-read-more-container').addClass('hidden');
			$('.pci-read-more-link').removeClass('hidden');
			$('div.payment-method-tile').removeClass('payment-method-tile-active');

			if ($additionalInfo.length) {
				// Do not save payment method by default
				const $paymentMethodCanBeSaved = $additionalInfo.find('input.remember-method');
				if ($paymentMethodCanBeSaved.length) {
					$info.addClass('payment-method-tile-active');
					$additionalInfo.removeClass('hidden');
					$paymentMethodCanBeSaved.prop('checked', false);
				}
			}

			if ($input.add($currentPaymentMethod).hasClass('has-fees')) {
				const action = getCart(true, {
					paymentMethod: $input.val(),
					orderId
				});
				$('.checkout-cart').trigger('cartaction', [action]);
			}

			const { panhash } = $input.data();
			$container.find('.payment-methods-container input#panhash').val(panhash || '');
			const paymentMethodName = $input.closest('label').find('.payment-method-name').text();
			gtm.checkout.selectPaymentMethod(paymentMethodName);
			$currentPaymentMethod = $input;
		})
		// Read PCI discalimer
		.on('click', '.pci-read-more-link', e => {
			e.preventDefault();
			const $this = $(e.target);
			const $pciContainer = $this
				.parentsUntil('.payment-method-additional-info')
				.closest('div')
				.next();
			$pciContainer.removeClass('hidden');
			$this.addClass('hidden');
		})
		// Hide PCI disclaimer
		.on('click', '.pci-close-read-more-link', e => {
			e.preventDefault();
			const $this = $(e.target);
			// Hide "show less" link
			($this.parent().parent()).addClass('hidden');
			const $readMoreLink = $this.parent().parent().parent().find('a.pci-read-more-link');
			$readMoreLink.removeClass('hidden');
		})
		// Remember payment method checkbox: Get checked property boolean value and change it's value accordingly
		.on('click', '.styled-checkbox', e => {
			e.preventDefault();
			const $this = $(e.target);
			const $rememberMethodCheckbox = $this.parent().find('.remember-method');
			const $propertyBoolean = !$rememberMethodCheckbox.prop('checked');
			$rememberMethodCheckbox.prop('checked', $propertyBoolean);
		})
		// Set custom sale code
		.on('click', '.apply-sale-code', e => {
			setSaleCode($('#set-salecode').val(), true)
		})
		// @TODO Refactor deprecated 'keyCode'
		.on('keydown', '#set-salecode', e => {
			if (e.keyCode === 13 || e.which === 13) {
				$container.find('.apply-sale-code').click();
			}
		})
		// Remove sale code
		.on('click', '.sale-code-remove', e => {
			e.preventDefault();
			const isSaleCodeActive = !!$container.find('.available-sale-codes').data('active-code')
			const $input = $('input[name="salecode"]');
			const isCustom = $(e.target).hasClass('custom-sale-code-remove');
			if (isSaleCodeActive) {
				setSaleCode('', isCustom).tap(() => $input.prop('checked', false));
			} else {
				$input.prop('checked', false)
				$('.sale-code-input, .sale-code-remove').addClass('hidden')
			}
		})
		// Select sale code from list
		.on('change', 'input[name="salecode"]', e => {
			const $input = $(e.target)
			if ($input.attr('value') === 'custom') {
				const isSaleCodeActive = !!$container.find('.available-sale-codes').data('active-code');
				if (isSaleCodeActive) {
					setSaleCode('', true).tap(() => $input.prop('checked', false));
				}
				$input.closest('li').find('.sale-code-input').removeClass('hidden')
			} else {
				const voucherId = $input.data('voucher-id') || '';
				setSaleCode($input.val(), false, voucherId);
			}
		})
		// Show all payment methods
		.on('click', '.show-all-payment-methods', e => {
			e.preventDefault();
			$('.all-payment-methods').removeClass('hidden');
			$(e.target).addClass('hidden');
		})
		// Delete saved credit card
		.on('click', '.delete-card', e => {
			e.preventDefault();
			const $this = $(e.target);
			const uuid = $this.data('uuid');
			/* eslint no-alert: off */
			if (uuid && confirm('Haluatko varmasti poistaa kortin tiedot?')) {

				const $deletedCardTileContainer = $this.parentsUntil('.payment-method-category');
				deleteSavedCard(uuid)
					.then(() => {
						hideSavedCard($deletedCardTileContainer);
					})
					.catch(console.error);
			}
		});

	const hasOffers = $('.available-sale-codes li').length > 1;
	if (!hasOffers) {
		$('.available-sale-codes li input[type="radio"]').prop('checked', true).change();
	} else if ($('.available-sale-codes li input[type="radio"]:checked').length === 0) {
		$('.available-sale-codes li:first-child').find('input[type="radio"]').prop('checked', true).change();
	}

	readMoreToggle();

	const $saleCodeInput = $container.find('input[name="salecode"]');

	if ($saleCodeInput.is(':checked')) {
		if ($saleCodeInput.attr('value') === 'custom') {
			$saleCodeInput.closest('li').find('.sale-code-input').removeClass('hidden')
		}
	}

	const currentPaymentMethod = $('input[name="stage-payment-provider"]').val();
	if (currentPaymentMethod) {
		Cookie.set('payment_method', currentPaymentMethod);
	}

	if ($('input[name="stage-payment-provider"][type="hidden"]').val() || $('input[name="stage-payment-provider"]:checked').val() || $container.hasClass('skip-contact')) {
		cta.enable();
	}
}
